import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetPersonResponse } from './get-person-response';
import { getPersonResponseSchema } from './get-person-response';

export async function getPersonApi(id: number): Promise<IValidatedResponse<IGetPersonResponse>> {
  return getRequest<IGetPersonResponse>({
    path: `/sys/people/v1/${id}`,
    schema: getPersonResponseSchema,
  });
}
